module.exports = __webpack_public_path__ + "img/rackspace-black.b5378844.svg";